import { useToasts } from "react-toast-notifications";

import { usePrettyLogEventPage } from "@components/v2/analytics";
import { PrimaryButton, SecondaryButton } from "@components/v2/buttons";
import { useOverviewContext } from "@features/overview-v2/hooks";
import { Modal } from "@shared/modal";

export const UpdateSavedViewModal = (props: {
  onClose: () => void;
  isOpen: boolean;
}) => {
  const {
    updateSavedViewFilters,
    saveViewsSavingState: { isSavingFilters },
  } = useOverviewContext();
  const prettyLogEventPage = usePrettyLogEventPage();
  const toast = useToasts();

  return (
    <Modal
      isOpen={props.isOpen}
      onClose={props.onClose}
      headerTitleProps={{ className: "text-xl font-semibold" }}
      titleContent={
        <div>Overwrite current view for all users on your account?</div>
      }
    >
      <p className="text-sm mb-8 text-[#717680]">Changes cannot be undone</p>
      <div className="flex items-center gap-2">
        <PrimaryButton
          loading={isSavingFilters}
          onClick={async () => {
            prettyLogEventPage({
              domain: "Saved Views",
              action: "onChange",
              additionalActionInfo: "Update Saved View",
            });
            await updateSavedViewFilters({
              errorMessage: "There was an error updating the view.",
              onSuccess: () => {
                props.onClose?.();
                toast.addToast("Saved view updated", {
                  appearance: "success",
                });
              },
            });
          }}
        >
          YES, SAVE
        </PrimaryButton>
        <SecondaryButton disabled={isSavingFilters} onClick={props.onClose}>
          NO, CANCEL
        </SecondaryButton>
      </div>
    </Modal>
  );
};
